import { Grid, Typography, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styles } from './modal-title-styles';

const ModalTitle: React.FC<IModalTitleProps> = (props: IModalTitleProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Grid container direction='column' className={props.className}>
      <Grid item className={'fullWidth'}>
        <Typography className={props.classes.dialogTitleText} data-testid='modal-title'>
          {t(props.title)}
        </Typography>
      </Grid>
      {!props.description ? null : (
        <Grid item className={'fullWidth'}>
          <Typography
            variant='body1'
            className={`${props.classes.dialogDescriptionText} customDialogDescription `}
            data-testid='modal-description'
          >
            {t(props.description)}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export interface IModalTitleProps extends WithStyles<typeof styles> {
  title: string;
  description?: string;
  className?: string;
}

export default withStyles(styles, { name: 'ModalTitle' })(ModalTitle);
